export default {
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field type.
     */
    type: {
      type: String,
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * If the input is clearable.
     */
    clearable: {
      type: Boolean,
      default: false,
    },

    /**
     * Max length of input.
     */
    maxlength: {
      type: Number,
      required: false,
      default: undefined,
    },
    hasButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonHandler: {
      type: Function,
      default: () => {},
      required: false,
    },
    buttonLabel: {
      type: String,
      required: false,
    },
    hasButton2: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonHandler2: {
      type: Function,
      default: () => {},
      required: false,
    },
    buttonLabel2: {
      type: String,
      required: false,
    },
  },

  methods: {
    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit('keydown', name, value);
      };
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  // eslint-disable-next-line
  render (h) {
    let autosize = null;
    if (this.type === 'textarea') {
      autosize = { minRows: 4 };
    }

    const input = <el-input
      value={this.value ? this.value.toString() : ''}
      autosize={autosize}
      disabled={this.disabled}
      onInput={this.onInput(this.name)}
      type={this.type}
      placeholder={this.translation ? this.$t(`${this.translation}.placeholder`) : this.name}
      name={this.name}
      maxlength={this.maxlength}
      clearable={this.clearable}

    />;
    let button = '';
    let button2 = '';

    if (this.hasButton) {
      button = <el-button onClick={this.buttonHandler} class="small" style="margin-left:5px"> {this.buttonLabel}</el-button>;
    }
    if (this.hasButton2) {
      button2 = <el-button onClick={this.buttonHandler2} class="small" style="margin-left:5px"> {this.buttonLabel2}</el-button>;
    }
    if (!this.insideForm) {
      return input;
    }

    let label = null;
    if (this.hasLabel) {
      label = this.translation ? this.$t(`${this.translation}.label`) : this.name;
    }

    return (
      <el-form-item
        error={this.error}
        label={label}
        class={this.name}
      >
        {input}
        {button}
        {button2}
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/text/text.jsx